var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "currentColor",
        viewBox: "0 0 256 256",
      },
    },
    [
      _c("rect", { attrs: { width: "256", height: "256", fill: "none" } }),
      _c("circle", {
        attrs: {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("path", {
        attrs: {
          d: "M168,128c0,64-40,96-40,96s-40-32-40-96,40-96,40-96S168,64,168,128Z",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("line", {
        attrs: {
          x1: "37.46",
          y1: "96",
          x2: "218.54",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("line", {
        attrs: {
          x1: "37.46",
          y1: "160",
          x2: "218.54",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }